import Lots from './Lots.jsx';

export default Lots;
